module.exports = __webpack_public_path__ + "img/ciic_logo.ba08b7bf.png";